const Achievers = [
  {
    Name: "Chinmay Sarangi",
    imgUrl: "/images/chinmay.jpg",
    about:"Chinmay scored 375 marks in JEE MAINS 2019 and scored 101% in boards exam. "
    
  },
  {
    Name: "Chinmay Sarangi",
    imgUrl: "/images/chinmay.jpg",
    about:"Chinmay scored 375 marks in JEE MAINS 2019 and scored 101% in boards exam. "
    
  },
  {
    Name: "Chinmay Sarangi",
    imgUrl: "/images/chinmay.jpg",
    about:"Chinmay scored 375 marks in JEE MAINS 2019 and scored 101% in boards exam. "
    
  },
  {
    Name: "Chinmay Sarangi",
    imgUrl: "/images/chinmay.jpg",
    about:"Chinmay scored 375 marks in JEE MAINS 2019 and scored 101% in boards exam. "
    
  },
  {
    Name: "Chinmay Sarangi",
    imgUrl: "/images/chinmay.jpg",
    about:"Chinmay scored 375 marks in JEE MAINS 2019 and scored 101% in boards exam. "
    
  },
  {
    Name: "Chinmay Sarangi",
    imgUrl: "/images/chinmay.jpg",
    about:"Chinmay scored 375 marks in JEE MAINS 2019 and scored 101% in boards exam. "
    
  }
];

export default Achievers;
